export default __webpack_public_path__ + "static/media/globe.bcdee142.png";